import React, { useEffect, useState } from "react";
import Select from "react-select";

const SelectBox = ({
  arrayData,
  setSelectedOption,
  selectedOption,
  disabled,
  style,
  isClearable,
  data,
  setData,
  width,
  setErr,
}) => {
  const [options, setOptions] = useState([]);

  // data and setData are not useful, but since I used these props in some pages, removing them may throw errors, so I’m keeping them.

  useEffect(() => {
    let options = arrayData?.map((item) => ({
      label: item?.companyName
        ? `${item?.companyId} - ${item?.companyName}`
        : item?.name,
      value: item?.companyName ? item?.companyName : item?.id,
    }));
    setOptions(options);
  }, [arrayData]);

  const handleChange = (event) => {
    console.log("event", event);
    setSelectedOption(event);
    setErr?.((prev) => ({ ...prev, option: "" }));
  };

  // console.log(data, 'data')
  // console.log(selectedOption, 'selectedOption')
  // console.log(options,options)

  return (
    <div className={!style ? "mt-2 mx-5" : ""}>
      <Select
        styles={{
          container: (base) => ({
            ...base,
            width: width ? width : "200px",
            position: "relative",
            zIndex: 1,
          }),
          menu: (base) => ({
            ...base,
            zIndex: 9999,
          }),
        }}
        menuPortalTarget={document.body}
        options={options}
        onChange={handleChange}
        value={selectedOption}
        isClearable={isClearable ?? true}
        isDisabled={disabled ? disabled : false}
      />
    </div>
  );
};

export default SelectBox;
